<template>
  <div class="d3">
    <h2>Weather Histogram</h2>
    <p>Message: {{message}}</p>

    <div class="form" v-if="selectedCity">
      <div>
        <label for="cities">City</label>
        <select
          v-model="selectedCity"
          @change="changeCity()"
          class="form-control"
          name="city"
          id="city"
        >
          <option v-for="(city,index) in cities" :key="index">{{ city }}</option>
        </select>
      </div>
      <div>
        <label for="cities">Year</label>
        <select
          v-model="selectedYear"
          @change="changeYear()"
          class="form-control"
          name="year"
          id="year"
        >
          <option v-for="(year,index) in years" :key="index">{{ year }}</option>
        </select>
      </div>
    </div>
    <div class="d3-viz advanced-chapter2" style="margin-bottom: 30px">
      <div class="tooltip" id="tooltip">
        <div class="tooltip-date" id="tooltip-date"></div>
        <div class="tooltip-temperature" id="tooltip-temperature">
          <span id="tooltip-temperature-min"></span>&nbsp;/
          <span id="tooltip-temperature-max"></span>
        </div>
        <div class="tooltip-metric tooltip-uv">
          <div>UV Index</div>
          <div id="tooltip-uv"></div>
        </div>
        <div class="tooltip-metric tooltip-cloud">
          <div>Cloud Cover</div>
          <div id="tooltip-cloud"></div>
        </div>
        <div class="tooltip-metric tooltip-precipitation-type">
          <div>Precipitation Type</div>
          <div id="tooltip-precipitation-type"></div>
        </div>
        <div class="tooltip-metric tooltip-precipitation">
          <div>Accum. / Intensity</div>
          <div id="tooltip-precipitation"></div>
        </div>
      </div>
    </div>
    <!-- First Graphic -->
    <div class="d3-viz advanced-chapter">
      <div id="tooltip-sp">
        <span id="date"></span>
        <span id="temperature"></span>
      </div>
    </div>

    <!-- <vue-json-pretty :path="'days'" :data="allData" :deep="3"></vue-json-pretty> -->
    <!-- <p>{{allData}}</p> -->
  </div>
</template>

<script>
import db from "@/firebase/init";
import {
  drawMarginalHistogram,
  redrawChart
} from "../d3-scripts/weather-histogram-export";

import {
  drawRadialChart,
  redrawRadialChart
} from "../d3-scripts/weather-radial";

// import VueJsonPretty from "vue-json-pretty";

export default {
  name: "weatherHistogramClass",
  data() {
    return {
      vizData: null,
      allData: null,
      message: null,
      indexObj: [],
      cities: [],
      years: [],
      selectedCity: null,
      selectedYear: null
    };
  },
  mounted() {
    this.getIndexFile();
  },

  components: {},
  methods: {
    async getFSData(redraw, vizSet) {
      try {
        this.message = "Start Loading";
        let currentDataFile = this.selectedCity + "-" + this.selectedYear;
        let weatherData = await db
          .collection("weather-data")
          .doc(currentDataFile)
          .get();
        this.allData = weatherData.data();
        this.vizData = this.allData.days;
        this.message = "Data loaded from Firestore";

        if (vizSet == 1) {
          redraw
            ? redrawChart(this.vizData)
            : drawMarginalHistogram(
                this.vizData,
                ".advanced-chapter",
                600,
                650
              );
        } else if (vizSet == 2) {
          // load second graph
          redraw
            ? redrawRadialChart(this.vizData)
            : drawRadialChart(this.vizData, ".advanced-chapter2", 600, 650);
        }
      } catch (error) {
        this.message = error;
      }
    },
    async getIndexFile() {
      let indexFile = await db.collection("weather-data").get();
      indexFile.forEach(element => {
        if (element.id != "index") {
          const data = element.data();
          let locationName = data.locationName;
          let year = data.year;
          this.cities.push(locationName);
          this.indexObj.push([locationName, year]);
        }
      });
      // keep only unique cities
      this.cities = this.cities.reduce((prev, current) => {
        // console.log(prev, current, prev.includes(current), [...prev, current]); // uncomment for better understanding
        return prev.includes(current) ? prev : [...prev, current];
      }, []);
      // Select first city as default
      this.selectedCity = this.cities[0];
      this.selectYears();
      this.selectedYear = this.years[0];

      // Finally build the graphic
      // this.getFSData(false, 1);
      this.getFSData(false, 2);
    },
    selectYears() {
      this.years = [];
      let count = 0;
      this.indexObj.forEach((element, i) => {
        if (this.indexObj[i][0] == this.selectedCity) {
          this.years[count] = this.indexObj[i][1];
          count++;
        }
      });
      this.years.sort().reverse();
    },
    changeCity() {
      this.selectYears();
      this.selectedYear = this.years[0];
      // this.getFSData(true, 1);
      this.getFSData(true, 2);
    },
    changeYear() {
      // this.getFSData(true, 1);
      this.getFSData(true, 2);
    }
  }
};
</script>

<style scoped lang="stylus">
@import './css/d3-styles.styl';
</style>



